export const EscolasInepFlexDataList = {
  element: $('input[name*="escola-inep"]'),
  groupBy: "estado",
  minLength: 3,
  searchIn: ["instituicao", "inep"],
  selectionRequired: true,
  valueProperty: "municipio",
  textProperty: "{instituicao} - {municipio} - {inep}",
  visibleProperties: ["instituicao", "municipio"],
  searchDelay: 500,
  searchContain: true,
  cache: false,
  delayLoading: 2000,
};
